<template>
  <div>
    <van-popup round style="width: 80%" v-model="showTag" @closed="onClosed">
      <h3 class="header tac fs18 pt10 pb10" v-if="title">{{ title }}</h3>
      <div class="pl15 tac pr15 pt20 pb20 fs14" v-if="message">
        <img :src="icon" alt="">
        <p class="mt10">{{ message }}</p>
      </div>
      <div class="footer pl15 pr15 pb15 pt15">
        <van-button type="info" class="mb10" block round @click="onClick('mobile')" v-if="mobileBtnText">
          {{ mobileBtnText }}
        </van-button>
        <van-button type="info" class="mb10" block round @click="onClick('address')" v-if="addressBtnText">
          {{ addressBtnText }}
        </van-button>
        <van-button round block @click="onClick('cancel')">取消</van-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
import {DIALOG_ICONS} from "@/plugins/dialog/config";

export default {
  name: "yygh-modify-address-or-mobile",
  components: {},
  data() {
    return {
      title: "",
      message: "",
      icon: DIALOG_ICONS.ERROR,
      mobileBtnText: '',
      addressBtnText: '',
      showTag: false
    }
  },
  methods: {
    open() {
      this.showTag = true;
    },
    close() {
      this.showTag = false;
    },
    onClosed() {
      if (this.remove) this.remove(this.type);
    },
    onClick(type) {
      this.type = type;
      this.close()
    }
  },
}
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/plugins/dialog/yygh-modify-address-or-mobile.vue